import { createContext, useContext } from 'react';

interface ContextState {
  openLimitModal: () => void;
}

export const AiUsageLimitModalContext = createContext<ContextState | undefined>(
  undefined,
);

export function useAiUsageLimitModal(): ContextState {
  const context = useContext(AiUsageLimitModalContext);

  if (!context) {
    return { openLimitModal: () => {} };
  }

  return context;
}
